/**
 * @generated SignedSource<<5c7ef9602af0aca58de0f331525a2fe9>>
 * @relayHash adadb3be1a833182a34f3dc5c4484f27
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d13edfa613392c389fcab9eaeb0f8baaed83a8ae14b7e3dc982f9aa13a83b10b

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type BoardsTabQuery$variables = {
  cloudAri: string;
  first?: number | null | undefined;
  query?: string | null | undefined;
};
export type BoardsTabQuery$data = {
  readonly search: {
    readonly result: {
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      };
      readonly totalCount: number | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"BoardsTable">;
    } | null | undefined;
  } | null | undefined;
};
export type BoardsTabQuery = {
  response: BoardsTabQuery$data;
  variables: BoardsTabQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudAri"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "query"
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "experience",
    "value": "jira.search"
  },
  {
    "fields": [
      {
        "kind": "Literal",
        "name": "entities",
        "value": [
          "jira.board"
        ]
      },
      {
        "items": [
          {
            "kind": "Variable",
            "name": "locations.0",
            "variableName": "cloudAri"
          }
        ],
        "kind": "ListValue",
        "name": "locations"
      }
    ],
    "kind": "ObjectValue",
    "name": "filters"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "query"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v3 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "BoardsTabQuery",
    "selections": [
      {
        "concreteType": "SearchQueryAPI",
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": [
          {
            "alias": "result",
            "args": (v1/*: any*/),
            "concreteType": "SearchItemConnection",
            "kind": "LinkedField",
            "name": "search",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "FragmentSpread",
                "name": "BoardsTable"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BoardsTabQuery",
    "selections": [
      {
        "concreteType": "SearchQueryAPI",
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": [
          {
            "alias": "result",
            "args": (v1/*: any*/),
            "concreteType": "SearchItemConnection",
            "kind": "LinkedField",
            "name": "search",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "SearchResultItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "title"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "url"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "boardId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "favourite"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "iconUrl"
                          },
                          {
                            "kind": "LinkedField",
                            "name": "container",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "projectId"
                                  },
                                  {
                                    "alias": "key",
                                    "kind": "ScalarField",
                                    "name": "projectKey"
                                  },
                                  {
                                    "alias": "name",
                                    "kind": "ScalarField",
                                    "name": "projectName"
                                  }
                                ],
                                "type": "SearchResultJiraBoardProjectContainer"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "userAccountId"
                                  },
                                  {
                                    "alias": "name",
                                    "kind": "ScalarField",
                                    "name": "userName"
                                  }
                                ],
                                "type": "SearchResultJiraBoardUserContainer"
                              }
                            ]
                          }
                        ],
                        "type": "SearchResultJiraBoard"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "d13edfa613392c389fcab9eaeb0f8baaed83a8ae14b7e3dc982f9aa13a83b10b",
    "metadata": {},
    "name": "BoardsTabQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f9eda10e11987e60a2f70fc693a8b275";

export default node;
